import React from 'react';
import { 
  FaFacebookF, FaInstagram, FaWhatsapp, FaPhone, FaEnvelope,
  FaMapMarkerAlt, FaHeart 
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '/#home' },
    { name: 'About Us', href: '/#about' },
    { name: 'Our Fleet', href: '/#fleet' },
    { name: 'Destinations', href: '/#destinations' },
  ];

  const services = [
    { name: 'Caravan Holidays', href: '/#fleet' },
    { name: 'Custom Tours', href: '/#destinations' },
    { name: 'Corporate Bookings', href: '/#contact' },
  ];

  const socialLinks = [
    { 
      icon: <FaFacebookF />, 
      href: 'https://www.facebook.com/holidayanywhere',
      color: 'hover:bg-blue-600',
      label: 'Facebook'
    },
    { 
      icon: <FaInstagram />, 
      href: 'https://www.instagram.com/wacationonwheels',
      color: 'hover:bg-pink-600',
      label: 'Instagram'
    },
    { 
      icon: <FaWhatsapp />, 
      href: 'https://wa.me/918380866111',
      color: 'hover:bg-green-600',
      label: 'WhatsApp'
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-primary-800 to-primary-900 text-white">
      {/* Main Footer Content */}
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div
              className="mb-6"
            >
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src={require('../assets/wowlogo.jpeg')} 
                  alt="WOW Caravans Logo" 
                  className="w-16 h-16 object-contain"
                />
                <div>
                  <h3 className="text-xl font-bold">WOW Caravans</h3>
                  <p className="text-accent-300 text-sm">Holiday Anywhere</p>
                </div>
              </div>
              <p className="text-primary-200 leading-relaxed mb-4">
                India's premier caravan travel service. Experience the freedom of the open road 
                with luxury and comfort.
              </p>
              <div className="flex space-x-3">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 bg-primary-700 rounded-full flex items-center justify-center ${social.color} transition-colors`}
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-accent-300">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li
                  key={index}
                >
                  <a 
                    href={link.href}
                    className="text-primary-200 hover:text-accent-300 transition-colors flex items-center space-x-2 group"
                  >
                    <span className="w-1.5 h-1.5 bg-accent-500 rounded-full group-hover:w-3 transition-all" />
                    <span>{link.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-accent-300">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li
                  key={index}
                >
                  <a 
                    href={service.href}
                    className="text-primary-200 hover:text-accent-300 transition-colors flex items-center space-x-2 group"
                  >
                    <span className="w-1.5 h-1.5 bg-accent-500 rounded-full group-hover:w-3 transition-all" />
                    <span>{service.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-accent-300">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-accent-400 flex-shrink-0 mt-1" />
                <span className="text-primary-200 text-sm">
                  Vishram, 158 B - hilltop Layout,<br />
                  Verma layout, Ambazari,<br />
                  Nagpur, Maharashtra - 440033
                </span>
              </li>
              <li>
                <a 
                  href="tel:+918380866111"
                  className="flex items-center space-x-3 text-primary-200 hover:text-accent-300 transition-colors"
                >
                  <FaPhone className="text-accent-400" />
                  <span>+91 83808-66111</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@wowcaravans.com"
                  className="flex items-center space-x-3 text-primary-200 hover:text-accent-300 transition-colors"
                >
                  <FaEnvelope className="text-accent-400" />
                  <span className="text-sm">info@wowcaravans.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-700">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-primary-300 text-sm text-center md:text-left">
              <p>
                © {currentYear} WOW Caravans Private Limited. All rights reserved.
              </p>
              <p className="text-xs mt-1 text-primary-400">
                CIN: U74999MH2018PTC306238 | Established 2016
              </p>
            </div>
            <div className="flex items-center space-x-2 text-primary-300 text-sm">
              <span>Made with</span>
              <span
              >
                <FaHeart className="text-red-500" />
              </span>
              <span>for Adventure Seekers</span>
            </div>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/918380866111"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center text-3xl shadow-2xl hover:bg-green-600 z-50"
        aria-label="Contact us on WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </footer>
  );
};

export default Footer;
